import { render, staticRenderFns } from "./cash-registers.vue?vue&type=template&id=57792936&"
import script from "./cash-registers.vue?vue&type=script&lang=js&"
export * from "./cash-registers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports